export default __webpack_public_path__ + "static/media/ic_usdt_40.7809a575.svg";